import { useState, useEffect, useRef } from "react";

const GOLD = "#C9A84C";
const DARK = "#0D0D0D";
const CARD = "#161616";
const CARD2 = "#1E1E1E";
const BORDER = "#2A2A2A";

const HAIR_TYPES = ["1A","1B","1C","2A","2B","2C","3A","3B","3C"];
const FACE_SHAPES = ["Oval","Round","Square","Heart","Diamond"];

const WEEKLY_TASKS = {
  "1A": ["Shampoo & Style","Dry Shampoo Refresh","Clarify & Condition","Water Refresh","Shampoo & Style","Clarify & Deep Treat","Rest Day"],
  "1B": ["Shampoo & Style","Water Refresh","Shampoo & Condition","Light Refresh","Shampoo or Refresh","Clarify","Rest Day"],
  "1C": ["Shampoo & Style","Water Reshape","Shampoo & Style","Dry Refresh","Shampoo if Needed","Deep Conditioning","Rest & Assess"],
  "2A": ["Sulphate-Free Wash & Define","Scrunch Refresh","Wash & Deep Treat","Water Scrunch","Wash & Define","Moisture Treatment","Rest Day"],
  "2B": ["Sulphate-Free Wash & Curl Cream","Argan Refresh","Wash or Assess","Water Scrunch","Wash & Style","Deep Conditioning","Rest Day"],
  "2C": ["Sulphate-Free Wash & Cream Define","Scrunch Refresh","Wash & Cream","Leave-In Refresh","Wash & Define","Deep Treatment","Rest & Note"],
  "3A": ["Sulphate-Free Wash & Define","Curl Cream Refresh","Wash or Co-Wash","Satin Pillow Night","Wash & Define","End Moisture","Rest & Assess"],
  "3B": ["Co-Wash & LOC Method","LOC Refresh","Co-Wash & Deep Treat","Water Scrunch","Co-Wash & LOC","Clarify if Due","Rest & Assess"],
  "3C": ["Co-Wash & LOC Heavy","Night Protection","Co-Wash & Deep Mask","Water Scrunch","Co-Wash & LOC Full","Scalp Care","Rest & Breakage Check"],
};
const TASK_DETAILS = {
  "1A": [
    {
      title: "Shampoo & Style",
      what: "Wash day. 1A oils fast so this is essential.",
      how: ["Use a lightweight volumising shampoo — not a moisturising one. It will weigh your hair flat.", "Apply a pea-sized amount of ultra-light water-based pomade to damp hair only. Never dry.", "Blow-dry upward from the roots using a comb or fingers to build lift against gravity.", "Lock with 20 seconds on the lowest heat. Walk away — do not touch it."],
      avoid: "Heavy pomades, waxes, or any oil-based product. They flatten 1A within the hour.",
    },
    {
      title: "Dry Shampoo Refresh",
      what: "No wash today. Extend the style using dry shampoo.",
      how: ["Apply dry shampoo directly to your roots. Massage in with fingertips for 60 seconds.", "Mist lightly with water to reactivate any remaining product.", "Reshape with your fingers only. No fresh wet product on top.", "Air-dry. Done in under 5 minutes."],
      avoid: "Washing again. 1A does not benefit from daily washing — it causes the scalp to over-produce oil.",
    },
    {
      title: "Clarify & Condition",
      what: "1A builds oil and product residue fast. Clarify today to reset completely.",
      how: ["Use a clarifying shampoo today — not your regular shampoo. It strips all buildup.", "Apply a lightweight leave-in conditioner to your ends only. Never the roots.", "Roots need zero conditioning. Product near roots accelerates oiliness.", "Style as normal after drying."],
      avoid: "Applying conditioner near the scalp or roots. This is the number one mistake for 1A.",
    },
    {
      title: "Water Refresh",
      what: "Lightest possible refresh. No washing, no new product unless absolutely necessary.",
      how: ["Mist your hair lightly with plain water.", "Reshape with your fingers in the direction of your style.", "Only add a tiny amount of volumising mousse at the root if the style is completely gone.", "Air-dry."],
      avoid: "Over-refreshing. 1A can actually look better on Day 3 with less interference, not more.",
    },
    {
      title: "Shampoo & Style",
      what: "Repeat your Monday wash routine. Consistency is the system.",
      how: ["Lightweight volumising shampoo.", "Pea-sized product maximum — emulsify between palms before applying.", "Apply to damp hair, not dry or soaking wet.", "Blow-dry upward and lock with low heat for 20 seconds."],
      avoid: "Using more product than yesterday. Less is always more for 1A.",
    },
    {
      title: "Clarify & Deep Treat",
      what: "Weekly reset. Clarify the scalp and deep condition the ends.",
      how: ["Clarifying shampoo wash — removes all product and oil buildup from the week.", "After rinsing, apply a lightweight deep conditioner to ends only for 10 minutes.", "Rinse with cold water to seal the cuticle.", "Scalp gets nothing today — let it breathe and regulate."],
      avoid: "Conditioning the scalp or roots. Keeping the root zone clean is everything for 1A.",
    },
    {
      title: "Rest Day",
      what: "No product. Let your scalp breathe and self-regulate.",
      how: ["Apply nothing today.", "Observe how your scalp behaves without intervention.", "Note in your tracker which days felt oiliest — that tells you your true wash frequency.", "If you must go out, plain water mist and fingers is the maximum."],
      avoid: "Adding product out of habit. Rest days are data collection days for your system.",
    },
  ],
 
  "1B": [
    {
      title: "Shampoo & Style",
      what: "Main wash day. 1B responds well to standard products applied correctly.",
      how: ["Wash with a medium-strength shampoo.", "Apply matte clay or a light pomade. Emulsify fully between palms until warm.", "Work product through damp hair from roots to ends evenly.", "Blow-dry on low for 30 seconds in the direction of your style to lock it."],
      avoid: "Heavy wax or oil-based products at the roots.",
    },
    {
      title: "Water Refresh",
      what: "No wash. Reactivate yesterday's product with water alone.",
      how: ["Mist until lightly damp — not soaking.", "Reshape with your fingers.", "Only add a tiny amount of product if the style has fully collapsed.", "Air-dry or 20 seconds low heat."],
      avoid: "Washing every day. Stretching washes trains your scalp to produce less oil over time.",
    },
    {
      title: "Shampoo & Condition",
      what: "Mid-week wash with conditioning on ends.",
      how: ["Wash with your regular shampoo.", "Apply a lightweight conditioner to your ends only — never from roots.", "Leave for 2 minutes, rinse with cool water.", "Style as Day 1."],
      avoid: "Conditioning at the roots. For 1B this accelerates midday oiliness.",
    },
    {
      title: "Light Refresh",
      what: "Minimal. Water and fingers only unless genuinely needed.",
      how: ["Water mist and finger reshape.", "Add product only if the style is completely undefined.", "This should take under 2 minutes."],
      avoid: "Applying product on top of existing product. Buildup is 1B's main enemy.",
    },
    {
      title: "Shampoo or Refresh",
      what: "Assess your scalp. Wash if oily, refresh if clean.",
      how: ["Check your scalp — if it feels greasy or hair is visibly flat, wash.", "If still clean, refresh with water and fingers only.", "Stick to pea-sized product regardless."],
      avoid: "Washing out of routine rather than actual need.",
    },
    {
      title: "Clarify",
      what: "Every two weeks: clarifying shampoo to remove all buildup.",
      how: ["Clarifying shampoo only today if it is your bi-weekly day.", "Otherwise standard shampoo.", "Light conditioner on ends only after washing.", "No heavy styling today — let hair reset."],
      avoid: "Over-clarifying. Once every two weeks is enough for 1B.",
    },
    {
      title: "Rest Day",
      what: "No product. Observe how many days before oiliness peaked.",
      how: ["Apply nothing.", "Note when the oil arrived this week — Day 2, Day 3, etc.", "This data refines your wash schedule for next week."],
      avoid: "Ignoring the observation. The tracker only works if you log what you notice.",
    },
  ],
 
  "1C": [
    {
      title: "Shampoo & Style",
      what: "Main wash day. 1C needs technique to control the volume.",
      how: ["Wash with medium shampoo.", "Apply a medium-weight styling cream to damp hair roots to ends.", "Blow-dry with a paddle brush in the direction of your style — this sets the shape.", "Apply 2–3 drops of argan oil to your ends only after blow-drying. Never roots."],
      avoid: "Blunt-cut styles and heavy pomades. 1C puffs horizontally with blunt cuts — always request point-cutting from your barber.",
    },
    {
      title: "Water Reshape",
      what: "No wash. Mist lightly and reshape by hand.",
      how: ["Mist lightly with water.", "Reshape with your hands in the direction of your style.", "Apply a tiny amount of cream to the ends only if they feel dry.", "Air-dry fully."],
      avoid: "Too much product. 1C is thick and holds shape. Excess product creates stiffness.",
    },
    {
      title: "Shampoo & Style",
      what: "Mid-week wash. Same as Monday.",
      how: ["Wash. Repeat the Day 1 routine exactly.", "If you are seeing the mushroom effect — hair puffing outward — tell your barber at the next visit. Point-cutting is the fix, not more product."],
      avoid: "Fighting the volume with extra product. The solution is always at the barber.",
    },
    {
      title: "Dry Refresh",
      what: "Minimal. Water mist and finger reshape only.",
      how: ["Water mist only.", "Finger reshape gently.", "No product today — give the hair a product-free day."],
      avoid: "Applying more cream on top of what is already in the hair.",
    },
    {
      title: "Shampoo if Needed",
      what: "Wash if the scalp needs it. Skip if still clean.",
      how: ["Check the scalp. If buildup is visible, wash.", "Keep your cream amount controlled — start smaller than you think.", "1C absorbs product fast. Add only if needed."],
      avoid: "Over-loading. Less product always looks better on 1C.",
    },
    {
      title: "Deep Conditioning",
      what: "Non-negotiable weekly treatment. Moisture prevents frizz and mushroom effect.",
      how: ["Apply a hydrating mask or deep conditioner from mid-shaft to ends.", "Leave on for 20–30 minutes.", "Rinse with cold water to seal the cuticle flat.", "This reduces frizz and humidity expansion significantly over time."],
      avoid: "Skipping this step. 1C without regular deep conditioning becomes harder to manage each week.",
    },
    {
      title: "Rest & Assess",
      what: "No product. Note where bulk returned this week.",
      how: ["Apply nothing today.", "Observe where the hair expanded or lost shape.", "Note it in your tracker — this goes directly into your next barber brief.", "The same expansion spot every week tells you exactly where to ask for more point-cutting."],
      avoid: "Ignoring the pattern. The tracker exists to catch exactly this.",
    },
  ],
 
  "2A": [
    {
      title: "Sulphate-Free Wash & Define",
      what: "Main wash day. The wave must be protected from the moment you start.",
      how: ["Wash with sulphate-free shampoo only. Sulphates destroy the 2A wave pattern over time.", "Apply light sea salt spray or wave mousse to soaking wet hair immediately after washing.", "Scrunch your hair gently upward with your hands to encourage the wave.", "Air-dry completely — no blow-dryer without a diffuser. Heat straightens 2A progressively."],
      avoid: "Brushing at any point. One brush stroke eliminates the wave entirely.",
    },
    {
      title: "Scrunch Refresh",
      what: "No wash. Reactivate the wave with water and gentle scrunching.",
      how: ["Mist with water until lightly damp.", "Scrunch once lightly upward from underneath.", "Set it down and do not touch it until fully dry.", "Add a tiny amount of mousse only if the wave has completely disappeared."],
      avoid: "Touching the hair while it dries. Even one touch breaks the wave and creates frizz.",
    },
    {
      title: "Wash & Deep Treat",
      what: "Wash with a moisture treatment to strengthen the wave pattern.",
      how: ["Sulphate-free wash.", "Apply a moisture mask from mid-shaft to ends for 20 minutes.", "Rinse with cool water.", "Apply sea salt spray or mousse immediately to wet hair and scrunch. Air-dry."],
      avoid: "Hot water rinses. Hot water opens the cuticle and allows moisture to escape faster.",
    },
    {
      title: "Water Scrunch",
      what: "Lightest possible refresh. Water and scrunching only.",
      how: ["Mist with water.", "Scrunch lightly once.", "No heat on non-wash days.", "Air-dry."],
      avoid: "Heat tools. 2A wave is fragile and heat accumulates damage progressively.",
    },
    {
      title: "Wash & Define",
      what: "Second wash of the week. Same sulphate-free routine.",
      how: ["Sulphate-free wash.", "Apply sea salt spray immediately to damp hair.", "Scrunch and air-dry fully.", "Observe whether the wave pattern is getting stronger week on week."],
      avoid: "Skipping the sea salt spray. The wave needs definition product applied wet every wash day.",
    },
    {
      title: "Moisture Treatment",
      what: "Weekly moisture day to protect the wave long-term.",
      how: ["Apply a moisture mask or deep conditioner to damp hair.", "Leave on for 20 minutes.", "Rinse cool.", "Mist and scrunch to style. Never brush — even on weekends."],
      avoid: "Brushing. The no-brush rule applies seven days a week for 2A.",
    },
    {
      title: "Rest Day",
      what: "No product. Observe whether the wave is strengthening week on week.",
      how: ["Apply nothing today.", "Compare to last Sunday — is the wave stronger, more defined, or lasting longer?", "Note it in your tracker.", "Fingers only if absolutely necessary."],
      avoid: "Product or heat. Rest days show you what your natural wave is actually doing.",
    },
  ],
 
  "2B": [
    {
      title: "Sulphate-Free Wash & Curl Cream",
      what: "Main wash day. The single most important rule: do not touch it while it dries.",
      how: ["Wash with sulphate-free shampoo. Go straight from wet to product without towel-drying.", "Apply light curl cream to soaking wet hair. Work through evenly.", "Scrunch once upward, set it down, and do not touch it again.", "Diffuse on lowest setting or air-dry completely. Touching it wet breaks the wave permanently for that day."],
      avoid: "Touching hair during drying. This is the most common cause of 2B frizz.",
    },
    {
      title: "Argan Refresh",
      what: "No wash. Mist to reactivate and add argan oil to ends after drying.",
      how: ["Mist with water lightly.", "Scrunch once to reactivate the wave.", "Once the hair is fully dry, apply 2–3 drops of argan oil to the ends only.", "Argan oil reduces second-day frizz without weighing the wave down."],
      avoid: "Applying argan oil while the hair is still wet. It goes on after completely dry.",
    },
    {
      title: "Wash or Assess",
      what: "Wash if oily. Skip if clean.",
      how: ["Check the scalp. If oily, wash and repeat the Day 1 routine exactly.", "If clean, do a simple water scrunch refresh.", "No deviation from the Day 1 routine on wash days."],
      avoid: "Over-washing. 2B can go 2–3 days between sulphate-free washes without stripping.",
    },
    {
      title: "Water Scrunch",
      what: "Water only. Hands off while it dries.",
      how: ["Mist with water.", "Scrunch once from underneath.", "Put it down. Do not touch it. Leave it alone until fully dry."],
      avoid: "Any heat today. Non-wash days are recovery days for the wave structure.",
    },
    {
      title: "Wash & Style",
      what: "End-of-week wash. Maintain the look going into the weekend.",
      how: ["Sulphate-free wash.", "Curl cream on wet hair, scrunch once, leave alone.", "Diffuse or air-dry.", "Last wash of the week — make the technique count."],
      avoid: "Rushing the dry. Diffusing on high or touching mid-dry creates the frizz you spent the week avoiding.",
    },
    {
      title: "Deep Conditioning",
      what: "Non-negotiable weekly moisture treatment.",
      how: ["Apply a moisture mask from mid-shaft to ends.", "Leave for 20–30 minutes.", "Rinse with cool water.", "This keeps the 2B wave defined and frizz-free week after week."],
      avoid: "Skipping this. 2B wave without weekly deep conditioning becomes progressively harder to define.",
    },
    {
      title: "Rest Day",
      what: "No product. Note which days the wave was most defined this week.",
      how: ["Apply nothing.", "Which day had the clearest wave? Day 1 or Day 2?", "This tells you whether your product routine is working.", "Log it in your tracker."],
      avoid: "Any product or heat.",
    },
  ],
 
  "2C": [
    {
      title: "Sulphate-Free Wash & Cream Define",
      what: "Most important wash day. Work with the wave — never against it.",
      how: ["Sulphate-free wash only. Remove sulphate shampoos from your routine permanently.", "Apply moisture-rich cream to soaking wet hair. Define the wave section by section, scrunching upward.", "Diffuse on low or air-dry completely.", "Embrace the volume — do not try to flatten it. 2C volume is an asset."],
      avoid: "Any sulphate shampoo. Check every bottle — sodium lauryl sulphate destroys 2C definition.",
    },
    {
      title: "Scrunch Refresh",
      what: "No wash. Mist and light scrunch only.",
      how: ["Mist with water.", "Scrunch lightly from underneath.", "Air-dry.", "No product on dry hair — it creates frizz, not definition."],
      avoid: "Product on dry hair. 2C product must always go on wet or damp hair.",
    },
    {
      title: "Wash & Cream",
      what: "Mid-week wash. Same routine as Day 1.",
      how: ["Sulphate-free wash.", "Same cream application as Day 1.", "Are sulphate products creeping back in anywhere? Check and remove them."],
      avoid: "Any compromise on sulphate-free. Even one sulphate wash sets definition back significantly.",
    },
    {
      title: "Leave-In Refresh",
      what: "Water and fingers only. Leave-in only if ends are dry.",
      how: ["Water mist.", "Finger refresh gently.", "Apply a tiny drop of leave-in to ends only if they feel brittle."],
      avoid: "Heavy product on the refresh. 2C is thick and product accumulates fast.",
    },
    {
      title: "Wash & Define",
      what: "End-of-week wash. Define and embrace the volume.",
      how: ["Sulphate-free wash.", "Moisture-rich cream section by section, scrunching upward.", "Diffuse or air-dry.", "Embrace the volume."],
      avoid: "Fighting the natural direction of the wave. 2C only works with it, never against.",
    },
    {
      title: "Deep Treatment",
      what: "30 minutes minimum. Non-negotiable for 2C.",
      how: ["Apply a moisture mask from scalp to ends.", "Leave for minimum 30 minutes — longer if possible.", "Rinse cool.", "2C without this weekly treatment loses definition faster than any other wavy type."],
      avoid: "Rushing this. 30 minutes is the minimum. 45 is better.",
    },
    {
      title: "Rest & Note",
      what: "No product. Note how the wave responded to sulphate-free care.",
      how: ["Apply nothing.", "Compare this week's wave definition to Week 1.", "Improvement should be visible within 2–3 weeks of sulphate-free washing.", "Note what you observe in your tracker."],
      avoid: "Any product or heat.",
    },
  ],
 
  "3A": [
    {
      title: "Sulphate-Free Wash & Define",
      what: "Main wash day. Moisture and definition are the two priorities.",
      how: ["Wash with sulphate-free shampoo. 3A loses moisture fast — sulphates make this worse.", "Apply curl-defining cream to soaking wet hair section by section.", "Scrunch each section upward to encourage the spiral to form.", "Diffuse on the lowest setting or air-dry. Do not touch while drying."],
      avoid: "Brushing. Use a wide-tooth comb on wet, conditioned hair only.",
    },
    {
      title: "Curl Cream Refresh",
      what: "Reactivate Day 1 curls with water and a small amount of curl cream.",
      how: ["Mist until damp.", "Apply small amount of curl cream to sections that lost definition.", "Scrunch gently upward.", "Air-dry or diffuse on lowest setting."],
      avoid: "Applying cream to dry hair — it creates white cast and frizz. Always mist first.",
    },
    {
      title: "Wash or Co-Wash",
      what: "Mid-week wash. Also the most important deep conditioning day.",
      how: ["Wash or co-wash (conditioner-only wash) to cleanse without stripping.", "Deep condition: moisture mask mid-shaft to ends for 20–30 minutes.", "This is the most important step of your week for 3A. Do not skip it.", "Rinse cool, define and diffuse as normal."],
      avoid: "Skipping the deep condition. 3A frizz is almost always caused by insufficient moisture.",
    },
    {
      title: "Satin Pillow Night",
      what: "Water mist refresh and a reminder about your satin pillowcase tonight.",
      how: ["Water mist and gentle scrunch to refresh.", "Use your satin pillowcase tonight without exception.", "Satin reduces overnight friction that creates morning frizz.", "This single habit makes Days 5 and 6 significantly easier."],
      avoid: "Cotton pillowcases. Cotton creates friction that destroys curl definition overnight.",
    },
    {
      title: "Wash & Define",
      what: "End of week wash. Enter the weekend with defined curls.",
      how: ["Sulphate-free wash.", "Curl cream section by section on wet hair.", "Diffuse or air-dry.", "Enter Saturday with hair that needs minimal intervention."],
      avoid: "Rushing. End-of-week technique is just as important as Monday.",
    },
    {
      title: "End Moisture",
      what: "Extra moisture to the ends if dry. Satin pillow tonight.",
      how: ["Apply extra curl cream to the ends if they feel dry or brittle.", "Light scrunch.", "Satin pillowcase tonight.", "No heat."],
      avoid: "Over-applying product to the roots. Moisture goes on ends and mid-lengths, not the scalp.",
    },
    {
      title: "Rest & Assess",
      what: "No product. Assess definition progress this week.",
      how: ["Apply nothing.", "Is definition improving? Are frizzy days becoming less frequent?", "Note it in your tracker.", "This weekly assessment tells you whether the routine is working."],
      avoid: "Product or heat.",
    },
  ],
 
  "3B": [
    {
      title: "Co-Wash & LOC Method",
      what: "Most important day of the week. The LOC method is the foundation of 3B health.",
      how: ["Co-wash to cleanse without stripping moisture.", "Apply LOC in exact order: Leave-in conditioner → Oil (jojoba or argan) → Cream.", "Each layer locks in the previous one. Never skip steps or reverse the order.", "Scrunch upward after each layer. Diffuse on the lowest setting."],
      avoid: "Brushing dry hair — ever. Any brush on dry 3B creates irreversible frizz until the next wash.",
    },
    {
      title: "LOC Refresh",
      what: "Reactivate yesterday's definition with water and minimal product.",
      how: ["Mist heavily with water to reactivate the curl.", "Scrunch to reactivate.", "Apply a small drop of leave-in if curls are very dry.", "Wide-tooth comb only on wet hair if detangling is needed — never dry."],
      avoid: "Any comb or brush on dry hair. Detangling 3B must happen on wet, conditioned hair only.",
    },
    {
      title: "Co-Wash & Deep Treat",
      what: "Most important treatment day. Deep condition without exception.",
      how: ["Co-wash.", "Apply deep conditioning moisture mask root to ends.", "Leave for 20–30 minutes. Use a shower cap to trap heat and increase absorption.", "Rinse cool. Reapply LOC method. Diffuse."],
      avoid: "Skipping this day. 3B without weekly deep conditioning becomes progressively brittle.",
    },
    {
      title: "Water Scrunch",
      what: "Lightest refresh. Water and scrunch. Satin pillow tonight.",
      how: ["Water and scrunch refresh only.", "Satin pillowcase tonight without exception.", "The satin pillow halves your daily reactivation time by preserving definition overnight."],
      avoid: "Cotton pillowcases. Non-negotiable for 3B — friction destroys curl structure every night without satin.",
    },
    {
      title: "Co-Wash & LOC",
      what: "Second full LOC day. Enter the weekend with maximum moisture.",
      how: ["Co-wash or light wash.", "Full LOC: leave-in → oil → cream.", "Scrunch and diffuse on lowest setting.", "Weekend curls should be your best of the week."],
      avoid: "Rushing the LOC steps. Each layer needs time to absorb before the next is applied.",
    },
    {
      title: "Clarify if Due",
      what: "Every two weeks: clarifying shampoo to remove LOC buildup.",
      how: ["If bi-weekly clarify day: use a gentle clarifying shampoo.", "Follow immediately with deep conditioning for 20 minutes.", "Buildup from the LOC method must be cleared every 2 weeks.", "If not your clarify week, simply co-wash as normal."],
      avoid: "Over-clarifying. More than once every two weeks strips 3B of critical moisture.",
    },
    {
      title: "Rest & Assess",
      what: "No product. Note whether LOC is producing results.",
      how: ["Apply nothing.", "Compare this week's curl definition to last week.", "Are curls lasting longer between washes? Is frizz reducing?", "The LOC method takes 2–3 weeks to show full results."],
      avoid: "Product or manipulation.",
    },
  ],
 
  "3C": [
    {
      title: "Co-Wash & LOC Heavy",
      what: "3C has the highest moisture needs of all types. The LOC method must be heavy.",
      how: ["Co-wash or sulphate-free shampoo.", "Apply a heavy leave-in conditioner immediately to wet hair.", "Seal with castor oil or shea butter on the ends to lock moisture in.", "Apply thick curl cream as the final LOC layer. Diffuse on lowest or air-dry completely."],
      avoid: "Lightweight products. They sit on the surface without absorbing. 3C needs rich, thick, sealing products.",
    },
    {
      title: "Night Protection",
      what: "Refresh and protect. The most important 3C habit is night-time protection.",
      how: ["Mist lightly and scrunch gently to reactivate.", "Apply small amount of curl cream to any sections that dried out.", "Use your satin cap or pineapple method before sleep every single night.", "Without this, 3C curls are flat by morning and take significantly longer to restore."],
      avoid: "Sleeping without protection. This is the most important habit for 3C and the one most people skip.",
    },
    {
      title: "Co-Wash & Deep Mask",
      what: "Most important day of the week. 30–45 minute deep conditioning.",
      how: ["Co-wash.", "Apply a heavy deep conditioning mask.", "Leave for 30–45 minutes with a shower cap to maximise absorption.", "Rinse cool. Reapply full LOC method. Diffuse on lowest or air-dry."],
      avoid: "Lightweight conditioners or masks. 3C requires rich, thick formulas — thin products do not penetrate the curl structure.",
    },
    {
      title: "Water Scrunch",
      what: "Water only. Gentle scrunch. Night protection without exception.",
      how: ["Mist with water.", "Gentle scrunch.", "No heat.", "Satin cap or pineapple tonight."],
      avoid: "Any heat today. 3C heat damage accumulates faster than any other type.",
    },
    {
      title: "Co-Wash & LOC Full",
      what: "Second full LOC day. Maximum moisture before the weekend.",
      how: ["Co-wash.", "Full LOC method with heavy products.", "Going into the weekend with maximum moisture locked in.", "Satin cap tonight."],
      avoid: "Skimping on LOC layers. 3C moisture evaporates fast — each layer is essential.",
    },
    {
      title: "Scalp Care",
      what: "Apply castor oil to the scalp. 3-minute massage.",
      how: ["Apply castor oil directly to your scalp.", "Massage with your fingertips for 3 minutes — not your nails.", "This increases blood circulation to the follicles and supports healthy growth.", "Clinically supported for 3C scalp health and growth rate improvement."],
      avoid: "Skipping this step. Follicle health determines growth — scalp care is as important as hair care.",
    },
    {
      title: "Rest & Breakage Check",
      what: "No product. Assess breakage levels from this week.",
      how: ["Apply nothing today.", "Check your pillow and shower drain for shed hairs.", "50–100 hairs per day is normal and healthy.", "More than 100 per day consistently warrants a dermatologist consultation."],
      avoid: "Ignoring unusual shedding. Early action is most effective for 3C breakage.",
    },
  ],
};

const PHOTO_DAYS = [1, 7, 14, 30];

// ── HAIRSTYLE DATABASE ────────────────────────────────────────────────────
// Each style has: name, desc, barberScript, products, tags (hair types), length
const HAIRSTYLE_DB = {
  Oval: [
    {
      name: "Textured Quiff",
      desc: "Volume on top swept back with natural movement. Versatile for any occasion.",
      barberScript: "I want a textured quiff — longer on top with texture through it, tapered sides. Keep the fringe long enough to sweep back.",
      products: ["Matte clay (medium hold)", "Sea salt spray for texture"],
      tags: ["1B","1C","2A","2B"],
      length: "short",
      searchQuery: "textured quiff hairstyle men",
    },
    {
      name: "French Crop",
      desc: "Short textured top with a horizontal fringe just above the eyebrows. Low maintenance, always intentional.",
      barberScript: "I want a French crop — textured top with the fringe cut straight across just above my brows. Taper the sides.",
      products: ["Matte clay for texture", "Light pomade for fringe control"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "French crop haircut men",
    },
    {
      name: "Buzz Cut",
      desc: "Uniform short length all over. The purest, most effortless cut.",
      barberScript: "I want a buzz cut — number 3 on top, number 2 on the sides, number 1 at the bottom. Taper the neckline.",
      products: ["Scalp moisturiser", "Light SPF for exposed scalp"],
      tags: ["1A","1B","1C"],
      length: "short",
      searchQuery: "buzz cut hairstyle men",
    },
    {
      name: "Side Part",
      desc: "Classic, timeless. A clean parted look that works from casual to formal.",
      barberScript: "I want a classic side part — longer on top, taper the sides. I'll part it naturally.",
      products: ["Medium-hold pomade", "Fine-tooth comb to set the part"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "side part hairstyle men classic",
    },
    {
      name: "Undercut + Slick Back",
      desc: "Short sides with longer top swept straight back. Clean, sharp, confident.",
      barberScript: "I want an undercut — disconnected, close on the sides, keep plenty of length on top so I can slick it back.",
      products: ["High-shine pomade", "Light holding spray"],
      tags: ["1A","1B","1C","2A"],
      length: "medium",
      searchQuery: "undercut slick back hairstyle men",
    },
    {
      name: "Curtain Fringe",
      desc: "Centre-parted fringe that falls on either side of the face. Soft, modern, extremely popular.",
      barberScript: "I want curtains — centre part, longer fringe falling on both sides of my face. Keep the sides soft.",
      products: ["Light hold cream", "Round brush blow-dry for shape"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "medium",
      searchQuery: "curtain fringe hairstyle men",
    },
    {
      name: "Pompadour",
      desc: "Height and volume at the front, swept upward and back. Bold and extremely well-structured.",
      barberScript: "I want a pompadour — volume and height at the front, keep the top long enough to build the height.",
      products: ["Strong-hold pomade", "Blow-dryer with a comb for volume"],
      tags: ["1B","1C","2A"],
      length: "medium",
      searchQuery: "pompadour hairstyle men",
    },
    {
      name: "Faux Hawk",
      desc: "Shorter sides with height through the centre. Wearable and edgy at the same time.",
      barberScript: "I want a faux hawk — keep length in the centre and style it up slightly forward. No mohawk — just height through the middle.",
      products: ["Strong matte clay for hold", "Light hair spray to lock height"],
      tags: ["1B","1C","2A","2B"],
      length: "medium",
      searchQuery: "faux hawk hairstyle men",
    },
    {
      name: "Medium Length with Layers",
      desc: "Hits between the ear and shoulder. Layers add movement and prevent bulkiness.",
      barberScript: "I want medium-length hair with layers for movement. Keep the length around the jaw, point-cut the ends.",
      products: ["Light cream for definition", "Argan oil for ends"],
      tags: ["2A","2B","2C","3A"],
      length: "long",
      searchQuery: "medium length layered hair men",
    },
    {
      name: "Flow",
      desc: "Longer hair swept back naturally. Effortless, relaxed, and timeless.",
      barberScript: "I want a flow — keep the length, just clean up the shape and take out any bulk. Let it fall naturally.",
      products: ["Light leave-in cream", "Argan oil on ends"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "long",
      searchQuery: "flow hairstyle men long hair",
    },
  ],

  Round: [
    {
      name: "High Textured Crop",
      desc: "Short, tightly tapered sides with messy upward texture on top. Adds height and creates the illusion of a longer face without a skin fade.",
      barberScript: "I want a high textured crop — taper the sides tight without a skin fade, keep the top long enough to push up with texture and work it upward. Round face so I need the height.",
      products: ["Matte clay pushed upward", "Light spray to lock the height"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "high textured crop haircut men round face",
    },
    {
      name: "Angular Fringe",
      desc: "A fringe cut at an angle. Breaks the softness of a round face with diagonal lines.",
      barberScript: "I want an angular fringe — cut it on an angle so it goes longer on one side. The angle should break the roundness of my face.",
      products: ["Light pomade to direct the fringe angle", "Sea salt spray"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "angular fringe haircut men",
    },
    {
      name: "Messy Crop with Fringe",
      desc: "Short crop with choppy texture sitting forward. Works well styled slightly off-centre.",
      barberScript: "I want a messy crop — textured on top, fringe sitting forward. Cut it choppy at the ends not blunt.",
      products: ["Matte clay scrunched through damp hair", "Sea salt spray"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "messy crop fringe haircut men",
    },
    {
      name: "Ivy League Cut",
      desc: "Clean, preppy short cut with a side part and slight taper. Adds definition to a soft face.",
      barberScript: "I want an Ivy League cut — classic side part, taper the sides, keep the top short but long enough to part neatly.",
      products: ["Light pomade", "Fine comb for clean part"],
      tags: ["1A","1B","1C"],
      length: "short",
      searchQuery: "Ivy League haircut men",
    },
    {
      name: "Pompadour",
      desc: "Big upward volume at the front with tight sides. The added height counteracts the width of a round face perfectly.",
      barberScript: "I want a pompadour — keep plenty of length on top so I can blow it up and back for volume. Round face so I need the height.",
      products: ["Strong-hold pomade", "Blow-dryer comb for volume build"],
      tags: ["1B","1C","2A"],
      length: "medium",
      searchQuery: "pompadour haircut men round face",
    },
    {
      name: "Faux Hawk",
      desc: "Central ridge of height from front to back. Pulls the eye vertically — exactly what a round face needs.",
      barberScript: "I want a faux hawk — keep height in the centre strip, styled upward. Round face so vertical height is the goal.",
      products: ["Strong clay for hold", "Hair spray for all-day height"],
      tags: ["1B","1C","2A","2B"],
      length: "medium",
      searchQuery: "faux hawk haircut men",
    },
    {
      name: "Side Swept Undercut",
      desc: "Long top swept strongly to one side. The diagonal sweep adds length and breaks up softness.",
      barberScript: "I want a side swept undercut — longer top swept hard to one side, close on the other. Round face so I need that diagonal movement.",
      products: ["Medium pomade", "Blow-dry in the sweep direction first"],
      tags: ["1B","1C","2A","2B"],
      length: "medium",
      searchQuery: "side swept undercut hairstyle men",
    },
    {
      name: "Quiff with Height",
      desc: "The quiff's upward sweep combined with height makes a round face appear noticeably longer.",
      barberScript: "I want a quiff — top long enough to blow forward and up for a quiff shape. Round face so I need the height.",
      products: ["Pomade or clay blown forward and upward", "Light hairspray"],
      tags: ["1A","1B","1C","2A"],
      length: "medium",
      searchQuery: "quiff haircut men volume round face",
    },
    {
      name: "Bro Flow",
      desc: "Longer hair that falls naturally past the ears. When unstyled or lightly tousled, works well with a round face.",
      barberScript: "I want a bro flow — keep the length, just clean up the ends. Let it fall naturally with some movement.",
      products: ["Light leave-in cream", "Sea salt spray for texture"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "long",
      searchQuery: "bro flow long hair men",
    },
    {
      name: "Wavy Volume Mid-Length",
      desc: "Medium length waves with volume directed upward and away from the sides. Slims the face naturally.",
      barberScript: "I want medium length — work with the wave, keep volume more upward than outward. Round face so no width at the sides.",
      products: ["Light curl cream", "Diffuse for volume"],
      tags: ["2A","2B","2C","3A"],
      length: "long",
      searchQuery: "wavy medium length hair men round face",
    },
  ],

  Square: [
    {
      name: "Textured Crop",
      desc: "Short textured top with choppy ends. Movement and softness counterbalances a sharp jaw.",
      barberScript: "I want a textured crop — point-cut the ends for movement, nothing blunt. Keep everything soft. Square jaw so avoid anything harsh.",
      products: ["Matte clay", "Sea salt spray for texture"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "textured crop haircut men square face",
    },
    {
      name: "French Crop with Texture",
      desc: "Short structured top with a textured fringe sitting forward. Controlled without being rigid.",
      barberScript: "I want a French crop — textured top, fringe just above the brow. Soft taper on the sides. Choppy ends not blunt.",
      products: ["Matte clay", "Blow forward for fringe shape"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "French crop textured men",
    },
    {
      name: "Short Taper",
      desc: "Neat, close-cut sides that taper gradually. Keeps the jaw from looking even wider.",
      barberScript: "I want a short taper — taper the sides gradually with scissors, no skin fade or razor. Keep the top medium length with some texture. Square face.",
      products: ["Light matte clay", "Comb for top direction"],
      tags: ["1A","1B","1C"],
      length: "short",
      searchQuery: "short taper haircut men",
    },
    {
      name: "Side-Swept Quiff",
      desc: "Volume swept diagonally. The angled movement softens the straight edges of a square face.",
      barberScript: "I want a side-swept quiff — volume swept diagonally, not straight up. Square face so I need diagonal movement not vertical.",
      products: ["Medium pomade swept in direction", "Blow-dry the sweep shape first"],
      tags: ["1B","1C","2A"],
      length: "medium",
      searchQuery: "side swept quiff haircut men",
    },
    {
      name: "Messy Fringe",
      desc: "Dishevelled fringe falling forward. The contrast perfectly softens a rigid square structure.",
      barberScript: "I want a messy fringe — choppy, textured, falling forward and slightly to one side. Soft taper on the sides.",
      products: ["Sea salt spray", "Small amount of matte clay scrunched in"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "medium",
      searchQuery: "messy fringe haircut men",
    },
    {
      name: "Curtain Fringe",
      desc: "Parted centre fringe softly falling either side. The softness and centre part reduce the appearance of a wide jaw.",
      barberScript: "I want curtains — centre part, fringe falling on both sides softly. Soft taper on the sides. Square jaw so I need the softness.",
      products: ["Light hold cream", "Round brush to create the curtain shape"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "medium",
      searchQuery: "curtain fringe men square jaw",
    },
    {
      name: "Slicked-Back Texture",
      desc: "Top swept loosely back with visible texture — not too slick. Softer than a full slick back.",
      barberScript: "I want a textured slick-back — not too polished, some texture showing through. Square face so not too tight on the sides.",
      products: ["Medium-hold pomade with matte finish", "Run through with fingers, not a comb"],
      tags: ["1B","1C","2A"],
      length: "medium",
      searchQuery: "textured slick back hair men",
    },
    {
      name: "Medium Length with Layers",
      desc: "Longer hair with layered movement. The flow softens jaw angularity naturally.",
      barberScript: "I want medium length with layers — jaw length at most, point-cut the ends. I need the movement to soften my jaw.",
      products: ["Light cream for definition", "Argan oil on ends for softness"],
      tags: ["2A","2B","2C","3A"],
      length: "long",
      searchQuery: "medium length layered hair men square jaw",
    },
    {
      name: "Wolf Cut",
      desc: "Shaggy layered cut with volume at the crown and longer lengths at the back. Softens square angles naturally.",
      barberScript: "I want a wolf cut — lots of layers, shaggy texture, volume at the crown. Square face so I want the movement to work against my jaw.",
      products: ["Light curl cream or sea salt spray", "Diffuse or air-dry for natural texture"],
      tags: ["1C","2A","2B","2C","3A"],
      length: "long",
      searchQuery: "wolf cut men",
    },
    {
      name: "Loose Waves Styled",
      desc: "Natural or enhanced waves left loose. The organic curves directly counterbalance sharp square angles.",
      barberScript: "I have wavy hair — I want to keep it medium length and let the wave work. Just take out bulk and point-cut the ends.",
      products: ["Light curl cream on damp hair", "Diffuse or air-dry only"],
      tags: ["2A","2B","2C"],
      length: "long",
      searchQuery: "loose waves medium length men",
    },
  ],

  Heart: [
    {
      name: "Side Part",
      desc: "Classic parted look with volume that can be directed lower and wider. Adds visual width to the jaw area.",
      barberScript: "I want a classic side part — keep some length and width at the sides near my jawline. Heart face so I need width at the bottom not the top.",
      products: ["Light-medium pomade", "Comb to direct width downward"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "side part haircut men heart face",
    },
    {
      name: "Textured Crop with Fuller Sides",
      desc: "Short textured top with tapered sides that keep fullness and width near the jaw — no skin fade, so hair remains fuller where the face is narrowest.",
      barberScript: "I want a textured crop — taper the sides but keep them full, especially around jaw level. No skin fade. Heart face so I need width at the bottom not taken away.",
      products: ["Matte clay", "Sea salt spray"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "textured crop fuller sides men heart face",
    },
    {
      name: "Long Fringe",
      desc: "Fringe that falls to or below the brow line. Reduces forehead prominence and draws the eye down.",
      barberScript: "I want a long fringe — long enough to cover most of my forehead. Heart face so the forehead is wide and I need it covered.",
      products: ["Light hold cream", "Blow-dryer to direct fringe down"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "long fringe haircut men heart face",
    },
    {
      name: "Curtain Fringe",
      desc: "Centre-parted fringe that covers the upper forehead on both sides. Perfect for reducing a wide forehead.",
      barberScript: "I want curtains — centre part, fringe falling on both sides enough to reduce how wide my forehead looks. Keep some volume at the sides near the jaw.",
      products: ["Light cream", "Round brush blow-dry for the curtain shape"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "medium",
      searchQuery: "curtain fringe men heart face",
    },
    {
      name: "Soft Quiff",
      desc: "Low-volume quiff with soft movement. Keeps the look balanced without lifting the top too high.",
      barberScript: "I want a soft quiff — not too much height, just forward movement at the front. Don't go too short at the sides, I need width at jaw level.",
      products: ["Light-medium pomade", "Blow-dryer lightly forward"],
      tags: ["1A","1B","1C","2A"],
      length: "medium",
      searchQuery: "soft quiff low volume haircut men",
    },
    {
      name: "Fringed Undercut",
      desc: "Undercut with a long fringe falling forward. Covers the forehead while keeping it structured.",
      barberScript: "I want an undercut but with a fringe that falls forward and covers my forehead. Fringe comes forward not back.",
      products: ["Light pomade", "Blow-dryer directed forward"],
      tags: ["1B","1C","2A","2B"],
      length: "medium",
      searchQuery: "undercut with fringe forward men",
    },
    {
      name: "Wavy Medium Length",
      desc: "Medium length hair with natural wave. Volume at the sides adds width near the jaw to balance a narrow chin.",
      barberScript: "I want to keep my hair medium length and enhance the wave. Add volume at the sides especially near jaw level. Heart face so I need width at the bottom.",
      products: ["Light curl cream on damp hair", "Diffuse at sides for volume"],
      tags: ["2A","2B","2C"],
      length: "long",
      searchQuery: "wavy medium length hair men",
    },
    {
      name: "Layered Shag",
      desc: "Longer, layered cut with volume and movement at the ends. Builds visual width at the jaw level.",
      barberScript: "I want a shag cut — layered, longer, with the volume and fullness happening more at the ends near my jaw. Point-cut the layers.",
      products: ["Light curl cream", "Diffuse for volume at the ends"],
      tags: ["2A","2B","2C","3A"],
      length: "long",
      searchQuery: "shag haircut men layers",
    },
    {
      name: "Surf Hair",
      desc: "Longer, tousled, beach-wave style. Volume at the ends balances a narrow chin naturally.",
      barberScript: "I want surf hair — longer, tousled, with the ends fuller. Heart face so I want volume near my jaw not at the crown.",
      products: ["Sea salt spray", "Light leave-in cream"],
      tags: ["1C","2A","2B","2C"],
      length: "long",
      searchQuery: "surf hair men beach waves",
    },
    {
      name: "Medium Curly Natural",
      desc: "Natural curls at medium length with volume at the sides. Builds jaw-level width automatically.",
      barberScript: "I want to keep my curls at medium length. Shape it so there's more volume and width at the sides near my jaw. Heart face so I need width lower not higher.",
      products: ["Curl cream LOC method", "Diffuse for even volume"],
      tags: ["3A","3B","3C"],
      length: "long",
      searchQuery: "natural curly hair medium length men heart face",
    },
  ],

  Diamond: [
    {
      name: "Textured Crop with Fringe",
      desc: "Short textured top with a fringe that adds width at the forehead to balance wide cheekbones.",
      barberScript: "I want a textured crop with a fringe — the fringe should sit forward and add some width at my forehead. Diamond face so I need to balance the cheekbones.",
      products: ["Matte clay", "Sea salt spray for texture"],
      tags: ["1A","1B","1C","2A"],
      length: "short",
      searchQuery: "textured crop fringe diamond face men",
    },
    {
      name: "Classic Taper",
      desc: "Gradual taper on the sides with clean structured top. Keeps focus on the overall shape rather than the cheekbones.",
      barberScript: "I want a classic taper — scissors taper on the sides, gradual and soft. No skin fade or hard edge. Clean and structured on top. Diamond face so nothing too tight on the sides.",
      products: ["Light pomade", "Comb for clean direction"],
      tags: ["1A","1B","1C"],
      length: "short",
      searchQuery: "classic taper haircut men",
    },
    {
      name: "Fringe with Volume",
      desc: "Fuller fringe with volume pushed forward. Adds width at the top of the face to reduce cheekbone dominance.",
      barberScript: "I want a full fringe with volume at the front — pushed forward and slightly wide. Diamond face so I need width at the forehead level.",
      products: ["Light cream blown forward", "Sea salt spray for texture in the fringe"],
      tags: ["1A","1B","1C","2A","2B"],
      length: "short",
      searchQuery: "full fringe volume haircut men",
    },
    {
      name: "Curtains / Middle Part",
      desc: "Centre parted fringe falling either side. Adds forehead width and draws attention away from wide cheekbones.",
      barberScript: "I want curtains — centre part with the fringe falling on both sides. Diamond face so I need the fringe to add visual width at my forehead.",
      products: ["Light hold cream", "Round brush for the parted curtain"],
      tags: ["1B","1C","2A","2B","2C"],
      length: "medium",
      searchQuery: "curtains middle part men diamond face",
    },
    {
      name: "Soft Quiff",
      desc: "Gentle forward and upward volume at the front. Adds forehead width without drawing attention to the cheeks.",
      barberScript: "I want a soft quiff — low volume, gentle height, nothing aggressive. Diamond face so I need to add width at the forehead not emphasise the cheeks.",
      products: ["Light pomade", "Blow-dry forward and slightly up"],
      tags: ["1A","1B","1C","2A"],
      length: "medium",
      searchQuery: "soft quiff men diamond face",
    },
    {
      name: "Side Part with Texture",
      desc: "Classic side part with textured movement. The width of the part adds forehead balance.",
      barberScript: "I want a textured side part — not too clean, some movement through the top. Diamond face so I need some visual width at the forehead.",
      products: ["Medium matte pomade", "Run through with fingers after combing"],
      tags: ["1A","1B","1C","2A"],
      length: "medium",
      searchQuery: "side part texture haircut men",
    },
    {
      name: "Wavy Mid-Length",
      desc: "Medium length with natural wave. Softens the angular cheekbones and adds width above and below them.",
      barberScript: "I want to keep my hair medium length — work with the wave, add volume at the forehead and near the chin. Diamond face so I need to balance the wide cheekbones.",
      products: ["Light curl cream", "Diffuse for volume"],
      tags: ["2A","2B","2C"],
      length: "long",
      searchQuery: "wavy medium length men",
    },
    {
      name: "Layered Medium Cut",
      desc: "Layered at multiple lengths so volume is distributed evenly rather than concentrated at the cheekbones.",
      barberScript: "I want a layered medium cut — layers at different lengths to spread the volume evenly. Point-cut the ends. Diamond face so don't let all the volume sit at the widest point.",
      products: ["Light cream", "Argan oil on ends"],
      tags: ["2A","2B","2C","3A"],
      length: "long",
      searchQuery: "layered medium length men",
    },
    {
      name: "Natural Curls Mid-Length",
      desc: "Curls at medium length that soften and balance the angular structure of a diamond face naturally.",
      barberScript: "I want to keep my curls at medium length — shape it so the volume distributes evenly, not just at my cheekbones.",
      products: ["Curl cream", "LOC method", "Diffuse evenly"],
      tags: ["3A","3B","3C"],
      length: "long",
      searchQuery: "natural curls medium length men",
    },
    {
      name: "Shaggy Textured",
      desc: "Longer shaggy cut with lots of layers. Volume distributes across the whole head rather than at the cheekbones.",
      barberScript: "I want a shaggy layered cut — lots of texture, volume spread evenly. Diamond face so I need balance not emphasis at the cheekbones.",
      products: ["Sea salt spray", "Light curl cream for texture"],
      tags: ["1C","2A","2B","2C","3A"],
      length: "long",
      searchQuery: "shaggy textured hair men",
    },
  ],
};

const LENGTH_ORDER = ["short", "medium", "long"];
const LENGTH_LABELS = { short: "Short", medium: "Medium", long: "Long" };

function getTodayDayNum(startDate) {
  if (!startDate) return null;
  const start = new Date(startDate);
  const today = new Date();
  start.setHours(0,0,0,0);
  today.setHours(0,0,0,0);
  const diff = Math.floor((today - start) / (1000 * 60 * 60 * 24)) + 1;
  if (diff < 1 || diff > 30) return null;
  return diff;
}

function initDays() {
  const days = {};
  for (let i = 1; i <= 30; i++) {
    days[i] = { done: false, score: null, note: "", photo: null, lockedAt: null };
  }
  return days;
}

function ScoreButton({ value, selected, onClick }) {
  const col = value <= 3 ? "#e74c3c" : value <= 6 ? "#f39c12" : "#27ae60";
  return (
    <button onClick={onClick} style={{
      width: 36, height: 36, borderRadius: 6,
      border: `1.5px solid ${selected ? col : BORDER}`,
      background: selected ? col + "33" : "transparent",
      color: selected ? col : "#555",
      fontSize: 13, fontWeight: 700, cursor: "pointer",
      transition: "all 0.15s"
    }}>{value}</button>
  );
}

// ── STYLE CARD ─────────────────────────────────────────────────────────────
function StyleCard({ style, hairType }) {
  const [expanded, setExpanded] = useState(false);
  const suitsMine = style.tags.includes(hairType);
  const googleURL    = `https://www.google.com/search?q=${encodeURIComponent(style.searchQuery)}&tbm=isch`;
  const pinterestURL = `https://www.pinterest.com/search/pins/?q=${encodeURIComponent(style.searchQuery)}`;
  const youtubeURL   = `https://www.youtube.com/results?search_query=${encodeURIComponent(style.searchQuery + " tutorial")}`;

  return (
    <div style={{
      background: CARD,
      border: `1.5px solid ${suitsMine ? GOLD + "55" : BORDER}`,
      borderRadius: 12, marginBottom: 10, overflow: "hidden",
    }}>
      <div onClick={() => setExpanded(!expanded)} style={{
        padding: "14px 16px", cursor: "pointer",
        display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10,
      }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
            <span style={{ fontSize: 14, fontWeight: 800, color: suitsMine ? GOLD : "#ccc" }}>
              {style.name}
            </span>
            {suitsMine && (
              <span style={{
                fontSize: 8, fontWeight: 700, letterSpacing: 1,
                background: GOLD + "22", color: GOLD,
                padding: "2px 7px", borderRadius: 20,
              }}>SUITS YOU</span>
            )}
          </div>
          <div style={{ fontSize: 11, color: "#555", lineHeight: 1.5 }}>{style.desc}</div>
        </div>
        <div style={{
          fontSize: 18, color: expanded ? GOLD : "#444",
          transition: "transform 0.2s",
          transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
          flexShrink: 0,
        }}>›</div>
      </div>

      {expanded && (
        <div style={{ borderTop: `1px solid ${BORDER}` }}>
          {/* Barber script */}
          <div style={{ padding: "14px 16px", borderBottom: `1px solid ${BORDER}` }}>
            <div style={{ fontSize: 10, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>BARBER SCRIPT</div>
            <div style={{
              background: CARD2, borderRadius: 8, padding: "12px 14px",
              fontSize: 12, color: "#bbb", lineHeight: 1.7, fontStyle: "italic",
              borderLeft: `3px solid ${GOLD}`,
            }}>"{style.barberScript}"</div>
          </div>

          {/* Products */}
          <div style={{ padding: "14px 16px", borderBottom: `1px solid ${BORDER}` }}>
            <div style={{ fontSize: 10, color: "#555", fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>PRODUCTS</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              {style.products.map((p, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12, color: "#888" }}>
                  <div style={{ width: 5, height: 5, borderRadius: "50%", background: GOLD, flexShrink: 0 }} />
                  {p}
                </div>
              ))}
            </div>
          </div>

          {/* Search buttons */}
          <div style={{ padding: "14px 16px" }}>
            <div style={{ fontSize: 10, color: "#555", fontWeight: 700, letterSpacing: 2, marginBottom: 10 }}>SEE REAL PHOTOS</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <a href={googleURL} target="_blank" rel="noopener noreferrer" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                gap: 8, padding: "11px 14px", borderRadius: 8,
                background: "#1a1a2e", border: "1.5px solid #4285F4",
                color: "#4285F4", fontWeight: 700, fontSize: 12, textDecoration: "none",
              }}>Search Google Images</a>
              <a href={pinterestURL} target="_blank" rel="noopener noreferrer" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                gap: 8, padding: "11px 14px", borderRadius: 8,
                background: "#1a0808", border: "1.5px solid #E60023",
                color: "#E60023", fontWeight: 700, fontSize: 12, textDecoration: "none",
              }}>Search Pinterest</a>
              <a href={youtubeURL} target="_blank" rel="noopener noreferrer" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                gap: 8, padding: "11px 14px", borderRadius: 8,
                background: "#1a0a0a", border: "1.5px solid #FF0000",
                color: "#FF0000", fontWeight: 700, fontSize: 12, textDecoration: "none",
              }}>Watch Tutorial on YouTube</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [setup, setSetup] = useState(false);
  const [hairType, setHairType] = useState("");
  const [faceShape, setFaceShape] = useState("");
  const [days, setDays] = useState(initDays());
  const [view, setView] = useState("grid");
  const [selectedDay, setSelectedDay] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [photoLog, setPhotoLog] = useState({ 1:"", 7:"", 14:"", 30:"" });
  const [productLog, setProductLog] = useState("");
  const [barberNotes, setBarberNotes] = useState("");
  const [activeTab, setActiveTab] = useState("tracker");
  const [stylesFilter, setStylesFilter] = useState("mine");
  const [lengthFilter, setLengthFilter] = useState("all");
  const fileInputRef = useRef(null);
  const [uploadTargetDay, setUploadTargetDay] = useState(null);

  // Twemoji re-parse after every render
  useEffect(() => {
    if (window.twemoji) {
      window.twemoji.parse(document.body, {
        folder: "svg", ext: ".svg",
        base: "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/",
      });
    }
  });

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem("pf_tracker_v2");
      if (saved) {
        const d = JSON.parse(saved);
        setSetup(d.setup || false);
        setHairType(d.hairType || "");
        setFaceShape(d.faceShape || "");
        setDays(d.days || initDays());
        setStartDate(d.startDate || null);
        setPhotoLog(d.photoLog || { 1:"", 7:"", 14:"", 30:"" });
        setProductLog(d.productLog || "");
        setBarberNotes(d.barberNotes || "");
      }
    } catch(e) {}
  }, []);

  const saveAll = (updates = {}) => {
    const state = { setup, hairType, faceShape, days, startDate, photoLog, productLog, barberNotes, ...updates };
    try { localStorage.setItem("pf_tracker_v2", JSON.stringify(state)); } catch(e) {}
  };

  const updateDay = (dayNum, field, value) => {
    const updated = { ...days, [dayNum]: { ...days[dayNum], [field]: value } };
    setDays(updated);
    saveAll({ days: updated });
  };

  const getDayTask = (dayNum) => {
    if (!hairType) return "—";
    return (WEEKLY_TASKS[hairType] || [])[(dayNum - 1) % 7] || "—";
  };

  const getTaskDetail = (dayNum) => {
    if (!hairType) return null;
    const details = TASK_DETAILS[hairType];
    if (!details) return null;
    return details[(dayNum - 1) % 7] || null;
  };

  const todayDayNum = getTodayDayNum(startDate);

  const calcStreak = (daysObj) => {
    const upTo = todayDayNum || 1;
    let s = 0;
    for (let i = upTo; i >= 1; i--) {
      if (daysObj[i] && daysObj[i].done) s++;
      else break;
    }
    return s;
  };

  const completedCount = Object.values(days).filter(d => d.done).length;
  const streak = calcStreak(days);
  const avgScore = (() => {
    const scored = Object.values(days).filter(d => d.score);
    if (!scored.length) return null;
    return (scored.reduce((a, b) => a + b.score, 0) / scored.length).toFixed(1);
  })();

  const isDayLocked = (dayNum) => {
    const d = days[dayNum];
    if (!d || !d.lockedAt) return false;
    return new Date(d.lockedAt).toDateString() === new Date().toDateString();
  };

  const isDayAccessible = (dayNum) => {
    if (!todayDayNum) return dayNum === 1;
    return dayNum <= todayDayNum;
  };

  const handleStart = () => {
    if (!hairType || !faceShape) return;
    const sd = new Date().toISOString().split("T")[0];
    setSetup(true);
    setStartDate(sd);
    setSelectedDay(1);
    saveAll({ setup: true, hairType, faceShape, startDate: sd });
  };

  const handleMarkComplete = (dayNum) => {
    if (isDayLocked(dayNum) && days[dayNum].done) return;
    const updated = {
      ...days,
      [dayNum]: { ...days[dayNum], done: true, lockedAt: new Date().toISOString() }
    };
    setDays(updated);
    saveAll({ days: updated });
  };

  const handlePhotoUpload = (dayNum, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => updateDay(dayNum, "photo", ev.target.result);
    reader.readAsDataURL(file);
  };

  const triggerUpload = (dayNum) => {
    setUploadTargetDay(dayNum);
    setTimeout(() => fileInputRef.current && fileInputRef.current.click(), 50);
  };

  const goToPrev = () => { if (selectedDay > 1) setSelectedDay(selectedDay - 1); };
  const goToNext = () => { if (selectedDay < 30 && isDayAccessible(selectedDay + 1)) setSelectedDay(selectedDay + 1); };

  // ── SETUP SCREEN ─────────────────────────────────────────────────────────
  if (!setup) return (
    <div style={{ background: DARK, minHeight: "100vh", color: "#eee", fontFamily: "system-ui, sans-serif", paddingBottom: 40 }}>
      <div style={{ background: CARD, borderBottom: `1px solid ${BORDER}`, padding: "28px 24px 24px" }}>
        <div style={{ fontSize: 10, color: GOLD, letterSpacing: 3, fontWeight: 700 }}>PRIME FOLLICLE</div>
        <div style={{ fontSize: 26, fontWeight: 800, marginTop: 6 }}>30-Day Tracker</div>
        <div style={{ fontSize: 13, color: "#555", marginTop: 4 }}>Set up your system before you start</div>
      </div>
      <div style={{ maxWidth: 480, margin: "32px auto", padding: "0 20px" }}>
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: 28 }}>
          <div style={{ fontSize: 11, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 16 }}>YOUR HAIR TYPE</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 28 }}>
            {HAIR_TYPES.map(t => (
              <button key={t} onClick={() => setHairType(t)} style={{
                padding: "10px 18px", borderRadius: 8,
                border: `1.5px solid ${hairType === t ? GOLD : BORDER}`,
                background: hairType === t ? GOLD + "22" : "transparent",
                color: hairType === t ? GOLD : "#666",
                fontWeight: 700, fontSize: 14, cursor: "pointer", transition: "all 0.15s"
              }}>{t}</button>
            ))}
          </div>
          <div style={{ fontSize: 11, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 16 }}>YOUR FACE SHAPE</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 32 }}>
            {FACE_SHAPES.map(f => (
              <button key={f} onClick={() => setFaceShape(f)} style={{
                padding: "10px 18px", borderRadius: 8,
                border: `1.5px solid ${faceShape === f ? GOLD : BORDER}`,
                background: faceShape === f ? GOLD + "22" : "transparent",
                color: faceShape === f ? GOLD : "#666",
                fontWeight: 700, fontSize: 14, cursor: "pointer", transition: "all 0.15s"
              }}>{f}</button>
            ))}
          </div>
          <button onClick={handleStart} disabled={!hairType || !faceShape} style={{
            width: "100%", padding: 16, borderRadius: 10,
            background: hairType && faceShape ? GOLD : "#1a1a1a",
            color: hairType && faceShape ? "#000" : "#444",
            border: "none", fontWeight: 800, fontSize: 15,
            cursor: hairType && faceShape ? "pointer" : "not-allowed",
            letterSpacing: 1, transition: "all 0.2s"
          }}>START 30-DAY TRANSFORMATION</button>
        </div>
      </div>
    </div>
  );

  // ── DAY DETAIL SCREEN ─────────────────────────────────────────────────────
  if (view === "detail" && selectedDay) {
    const d = days[selectedDay];
    const task = getDayTask(selectedDay);
    const detail = getTaskDetail(selectedDay);
    const week = Math.ceil(selectedDay / 7);
    const isToday = selectedDay === todayDayNum;
    const isPhotoDay = PHOTO_DAYS.includes(selectedDay);
    const locked = isDayLocked(selectedDay) && d.done;
    const accessible = isDayAccessible(selectedDay);
    const canNext = selectedDay < 30 && isDayAccessible(selectedDay + 1);

    return (
      <div style={{ background: DARK, minHeight: "100vh", color: "#eee", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ background: CARD, borderBottom: `1px solid ${BORDER}`, padding: "12px 16px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <button onClick={() => setView("grid")} style={{
              background: "none", border: `1px solid ${BORDER}`, color: "#aaa",
              padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600
            }}>Back</button>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <button onClick={goToPrev} disabled={selectedDay <= 1} style={{
                width: 38, height: 38, borderRadius: 8,
                border: `1.5px solid ${selectedDay <= 1 ? "#222" : GOLD}`,
                background: selectedDay <= 1 ? "transparent" : GOLD + "11",
                color: selectedDay <= 1 ? "#333" : GOLD,
                fontSize: 20, cursor: selectedDay <= 1 ? "not-allowed" : "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700
              }}>‹</button>
              <div style={{ textAlign: "center", minWidth: 80 }}>
                <div style={{ fontSize: 10, color: "#444", letterSpacing: 1 }}>WEEK {week}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: isToday ? GOLD : "#eee" }}>Day {selectedDay}</div>
                {isToday && <div style={{ fontSize: 9, color: GOLD, fontWeight: 700, letterSpacing: 1 }}>TODAY</div>}
              </div>
              <button onClick={goToNext} disabled={!canNext} style={{
                width: 38, height: 38, borderRadius: 8,
                border: `1.5px solid ${!canNext ? "#222" : GOLD}`,
                background: !canNext ? "transparent" : GOLD + "11",
                color: !canNext ? "#333" : GOLD,
                fontSize: 20, cursor: !canNext ? "not-allowed" : "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700
              }}>›</button>
            </div>
            <div style={{ width: 60, textAlign: "right" }}>
              {isPhotoDay && <div style={{ fontSize: 20 }}>📷</div>}
            </div>
          </div>
        </div>

        <div style={{ maxWidth: 480, margin: "0 auto", padding: 16 }}>
          {locked && (
            <div style={{ background: "#0b220b", border: `1px solid #27ae60`, borderRadius: 10, padding: "14px 18px", marginBottom: 14, display: "flex", gap: 14, alignItems: "center" }}>
              <div style={{ fontSize: 26 }}>🔒</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#27ae60" }}>Day {selectedDay} submitted</div>
                <div style={{ fontSize: 12, color: "#6a6a6a" }}>Come back tomorrow for Day {selectedDay + 1}</div>
              </div>
            </div>
          )}
          {!accessible && (
            <div style={{ background: "#111", border: `1px solid #333`, borderRadius: 10, padding: "14px 18px", marginBottom: 14 }}>
              <div style={{ fontSize: 13, color: "#555" }}><span style={{ fontSize: 18, marginRight: 8 }}>🔐</span>Day {selectedDay} unlocks when you reach it.</div>
            </div>
          )}
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 20, marginBottom: 14, opacity: accessible ? 1 : 0.35 }}>
            <div style={{ fontSize: 10, color: "#666", fontWeight: 700, letterSpacing: 2, marginBottom: 10 }}>TODAY'S TASK</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: GOLD, marginBottom: detail ? 14 : 0 }}>{task}</div>

            {detail && (
              <>
                {/* What */}
                <div style={{ fontSize: 13, color: "#aaa", lineHeight: 1.65, marginBottom: 18 }}>{detail.what}</div>

                {/* How to do it */}
                <div style={{ marginBottom: 18 }}>
                  <div style={{ fontSize: 9, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 12 }}>HOW TO DO IT</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {detail.how.map((step, i) => (
                      <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                        <div style={{
                          minWidth: 22, height: 22, borderRadius: "50%",
                          background: GOLD + "22", border: `1.5px solid ${GOLD}55`,
                          color: GOLD, fontSize: 10, fontWeight: 800,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          flexShrink: 0, marginTop: 1,
                        }}>{i + 1}</div>
                        <div style={{ fontSize: 13, color: "#bbb", lineHeight: 1.65 }}>{step}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Avoid */}
                <div style={{
                  background: "#1a0a0a", border: "1px solid #3a1a1a",
                  borderRadius: 8, padding: "12px 14px",
                  display: "flex", gap: 10, alignItems: "flex-start",
                }}>
                  <div style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}>⚠️</div>
                  <div>
                    <div style={{ fontSize: 9, color: "#c0392b", fontWeight: 700, letterSpacing: 2, marginBottom: 4 }}>AVOID</div>
                    <div style={{ fontSize: 12, color: "#c0392b", lineHeight: 1.65, opacity: 0.9 }}>{detail.avoid}</div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 20, marginBottom: 14 }}>
            <div style={{ fontSize: 10, color: "#666", fontWeight: 700, letterSpacing: 2, marginBottom: 14 }}>COMPLETION</div>
            <button onClick={() => accessible && !locked && handleMarkComplete(selectedDay)} disabled={!accessible || locked} style={{
              width: "100%", padding: 16, borderRadius: 8,
              background: d.done ? "#0b220b" : (accessible && !locked) ? CARD2 : "#0e0e0e",
              border: `1.5px solid ${d.done ? "#27ae60" : (accessible && !locked) ? BORDER : "#1a1a1a"}`,
              color: d.done ? "#27ae60" : (accessible && !locked) ? "#888" : "#333",
              fontWeight: 800, fontSize: 15, cursor: (accessible && !locked) ? "pointer" : "not-allowed"
            }}>
              {d.done ? "✓  COMPLETED" : !accessible ? "NOT YET UNLOCKED" : "MARK DAY COMPLETE"}
            </button>
            {accessible && !d.done && <div style={{ fontSize: 11, color: "#444", textAlign: "center", marginTop: 10 }}>Each day can only be marked once</div>}
          </div>
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 20, marginBottom: 14, opacity: accessible ? 1 : 0.35 }}>
            <div style={{ fontSize: 10, color: "#666", fontWeight: 700, letterSpacing: 2, marginBottom: 14 }}>RATE YOUR RESULT TODAY (1–10)</div>
            <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
              {[1,2,3,4,5,6,7,8,9,10].map(n => (
                <ScoreButton key={n} value={n} selected={d.score === n} onClick={() => accessible && updateDay(selectedDay, "score", d.score === n ? null : n)} />
              ))}
            </div>
            {d.score && (
              <div style={{ marginTop: 14, fontSize: 13, padding: "12px 16px", borderRadius: 8, background: d.score <= 3 ? "#250a0a" : d.score <= 6 ? "#251c00" : "#0a220a", color: d.score <= 3 ? "#e74c3c" : d.score <= 6 ? "#f39c12" : "#27ae60" }}>
                {d.score <= 3 ? "Something needs to change — check Chapter 7 of the ebook" : d.score <= 6 ? "Making progress — note what could be better below" : "This is working — note exactly what you did so you can repeat it"}
              </div>
            )}
          </div>
          {isPhotoDay && accessible && (
            <div style={{ background: CARD, border: `1.5px solid ${GOLD}55`, borderRadius: 10, padding: 20, marginBottom: 14 }}>
              <div style={{ fontSize: 10, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 6 }}>📷  PHOTO DAY</div>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 16, lineHeight: 1.6 }}>Take a straight-on shot, hair styled as normal. This is your progress benchmark.</div>
              {d.photo ? (
                <div>
                  <img src={d.photo} alt={`Day ${selectedDay}`} style={{ width: "100%", borderRadius: 8, marginBottom: 10, maxHeight: 280, objectFit: "cover" }} />
                  <button onClick={() => updateDay(selectedDay, "photo", null)} style={{ width: "100%", padding: 10, borderRadius: 7, background: "transparent", border: `1px solid #c0392b`, color: "#c0392b", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>Remove Photo</button>
                </div>
              ) : (
                <button onClick={() => triggerUpload(selectedDay)} style={{ width: "100%", padding: 18, borderRadius: 8, boxSizing: "border-box", background: GOLD + "11", border: `1.5px dashed ${GOLD}`, color: GOLD, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                  📷  Upload Day {selectedDay} Photo
                </button>
              )}
            </div>
          )}
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 20, opacity: accessible ? 1 : 0.35 }}>
            <div style={{ fontSize: 10, color: "#666", fontWeight: 700, letterSpacing: 2, marginBottom: 12 }}>NOTES</div>
            <textarea value={d.note} onChange={e => accessible && updateDay(selectedDay, "note", e.target.value)} disabled={!accessible}
              placeholder="Products used  ·  What worked  ·  What didn't  ·  How long style held"
              style={{ width: "100%", minHeight: 100, background: CARD2, border: `1px solid ${BORDER}`, borderRadius: 8, color: "#ccc", fontSize: 13, padding: 14, resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "system-ui, sans-serif", lineHeight: 1.6 }}
            />
          </div>
        </div>
        <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => uploadTargetDay && handlePhotoUpload(uploadTargetDay, e)} />
      </div>
    );
  }

  // ── MAIN GRID ──────────────────────────────────────────────────────────────
  const tabs = ["tracker","styles","photos","products","barber"];
  const tabLabels = { tracker: "Tracker", styles: "Styles", photos: "Photos", products: "Products", barber: "Barber" };

  const allStylesForFace = HAIRSTYLE_DB[faceShape] || [];
  const baseFiltered = stylesFilter === "mine"
    ? allStylesForFace.filter(s => s.tags.includes(hairType))
    : allStylesForFace;
  const filteredStyles = lengthFilter === "all"
    ? baseFiltered
    : baseFiltered.filter(s => s.length === lengthFilter);

  // Group by length for display
  const groupedByLength = LENGTH_ORDER.reduce((acc, len) => {
    const items = filteredStyles.filter(s => s.length === len);
    if (items.length > 0) acc[len] = items;
    return acc;
  }, {});

  return (
    <div style={{ background: DARK, minHeight: "100vh", color: "#eee", fontFamily: "system-ui, sans-serif" }}>
      {/* Header */}
      <div style={{ background: CARD, borderBottom: `1px solid ${BORDER}`, padding: "18px 18px 16px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 10, color: GOLD, letterSpacing: 3, fontWeight: 700 }}>PRIME FOLLICLE</div>
            <div style={{ fontSize: 22, fontWeight: 800, marginTop: 2 }}>30-Day Transformation</div>
            <div style={{ fontSize: 12, color: "#444", marginTop: 3 }}>Type {hairType}  ·  {faceShape}</div>
          </div>
          {todayDayNum && (
            <div style={{ background: GOLD + "18", border: `1px solid ${GOLD}55`, borderRadius: 10, padding: "8px 14px", textAlign: "center" }}>
              <div style={{ fontSize: 9, color: GOLD, fontWeight: 700, letterSpacing: 1 }}>TODAY</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: GOLD }}>Day {todayDayNum}</div>
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
          {[
            { label: "Completed", value: `${completedCount}/30`, color: "#27ae60" },
            { label: "Avg Score",  value: avgScore ? `${avgScore}/10` : "—", color: GOLD },
            { label: "Streak",     value: streak > 0 ? `${streak} days` : "0 days", color: "#e67e22" },
          ].map(s => (
            <div key={s.label} style={{ flex: 1, background: CARD2, borderRadius: 8, padding: "11px 10px", border: `1px solid ${BORDER}` }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 10, color: "#444", marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14, background: "#1a1a1a", borderRadius: 4, height: 5, overflow: "hidden" }}>
          <div style={{ background: `linear-gradient(90deg, ${GOLD}, #e67e22)`, height: "100%", borderRadius: 4, width: `${(completedCount / 30) * 100}%`, transition: "width 0.4s ease" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 5 }}>
          <span style={{ fontSize: 10, color: "#333" }}>Day 1</span>
          <span style={{ fontSize: 10, color: "#555" }}>{Math.round((completedCount / 30) * 100)}%</span>
          <span style={{ fontSize: 10, color: "#333" }}>Day 30</span>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", borderBottom: `1px solid ${BORDER}`, background: CARD, overflowX: "auto" }}>
        {tabs.map(t => (
          <button key={t} onClick={() => setActiveTab(t)} style={{
            flex: "0 0 auto", padding: "13px 14px", border: "none",
            borderBottom: activeTab === t ? `2px solid ${GOLD}` : "2px solid transparent",
            background: "none", color: activeTab === t ? GOLD : "#555",
            fontWeight: 700, fontSize: 11, cursor: "pointer", letterSpacing: 0.5, whiteSpace: "nowrap",
          }}>{tabLabels[t]}</button>
        ))}
      </div>

      {/* ── TRACKER TAB ── */}
      {activeTab === "tracker" && (
        <div style={{ padding: 16 }}>
          {[1,2,3,4].map(week => (
            <div key={week} style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 10, color: "#3a3a3a", fontWeight: 700, letterSpacing: 2, marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
                WEEK {week}
                {week === Math.ceil((todayDayNum || 1) / 7) && (
                  <span style={{ fontSize: 9, background: GOLD + "22", color: GOLD, padding: "2px 8px", borderRadius: 6 }}>CURRENT</span>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 6 }}>
                {Array.from({ length: 7 }, (_, i) => {
                  const dayNum = (week - 1) * 7 + i + 1;
                  if (dayNum > 30) return <div key={i} />;
                  const d = days[dayNum];
                  const accessible = isDayAccessible(dayNum);
                  const isToday = dayNum === todayDayNum;
                  const isPhotoDay = PHOTO_DAYS.includes(dayNum);
                  let bColor = accessible ? BORDER : "#1c1c1c";
                  let bg = accessible ? "#111" : "#0a0a0a";
                  if (d.done) {
                    if (!d.score)          { bColor = "#27ae60"; bg = "#091709"; }
                    else if (d.score >= 8) { bColor = "#27ae60"; bg = "#091709"; }
                    else if (d.score >= 5) { bColor = "#e67e22"; bg = "#1a1200"; }
                    else                   { bColor = "#e74c3c"; bg = "#180808"; }
                  }
                  if (isToday) bColor = GOLD;
                  return (
                    <button key={dayNum} onClick={() => { if (accessible) { setSelectedDay(dayNum); setView("detail"); } }}
                      style={{ aspectRatio: "1", borderRadius: 8, border: `${isToday ? "2px" : "1.5px"} solid ${bColor}`, background: bg, cursor: accessible ? "pointer" : "default", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1, padding: 2, position: "relative", transition: "all 0.1s" }}>
                      {isPhotoDay && accessible && <div style={{ position: "absolute", top: 2, right: 2, fontSize: 9, lineHeight: 1 }}>📷</div>}
                      <div style={{ fontSize: 14, fontWeight: 800, color: isToday ? GOLD : accessible ? (d.done ? "#ccc" : "#555") : "#2a2a2a" }}>{dayNum}</div>
                      {d.done && d.score && <div style={{ fontSize: 9, fontWeight: 700, color: d.score >= 8 ? "#27ae60" : d.score >= 5 ? "#e67e22" : "#e74c3c" }}>{d.score}/10</div>}
                      {d.done && !d.score && <div style={{ fontSize: 11, color: "#27ae60" }}>✓</div>}
                      {!accessible && <div style={{ fontSize: 9, color: "#2a2a2a" }}>🔐</div>}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", paddingTop: 16, borderTop: `1px solid ${BORDER}` }}>
            {[{ color: "#27ae60", label: "8–10 score" },{ color: "#e67e22", label: "5–7 score" },{ color: "#e74c3c", label: "1–4 score" },{ color: GOLD, label: "Today" },{ color: "#2a2a2a", label: "Locked" }].map(item => (
              <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ width: 10, height: 10, borderRadius: 2, background: item.color }} />
                <span style={{ fontSize: 10, color: "#444" }}>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── STYLES TAB ── */}
      {activeTab === "styles" && (
        <div style={{ padding: 16 }}>
          {/* Info card */}
          <div style={{ background: CARD, border: `1px solid ${GOLD}33`, borderRadius: 12, padding: 16, marginBottom: 14 }}>
            <div style={{ fontSize: 10, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 6 }}>YOUR COMBINATION</div>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#eee", marginBottom: 4 }}>
              {faceShape} Face  ·  Type {hairType} Hair
            </div>
            <div style={{ fontSize: 12, color: "#555", lineHeight: 1.6 }}>
              Tap any style for the exact barber script, products, and real photo search.
            </div>
          </div>

          {/* Mine / All filter */}
          <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
            {[["mine","Best For Me"],["all","All " + faceShape]].map(([val, label]) => (
              <button key={val} onClick={() => setStylesFilter(val)} style={{
                flex: 1, padding: "10px 8px", borderRadius: 8, border: "none",
                background: stylesFilter === val ? GOLD : CARD2,
                color: stylesFilter === val ? "#000" : "#555",
                fontWeight: 700, fontSize: 12, cursor: "pointer", transition: "all 0.15s",
              }}>{label}</button>
            ))}
          </div>

          {/* Length filter */}
          <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
            {[["all","All Lengths"],["short","Short"],["medium","Medium"],["long","Long"]].map(([val, label]) => (
              <button key={val} onClick={() => setLengthFilter(val)} style={{
                flex: 1, padding: "8px 4px", borderRadius: 8,
                border: `1.5px solid ${lengthFilter === val ? GOLD : BORDER}`,
                background: lengthFilter === val ? GOLD + "22" : "transparent",
                color: lengthFilter === val ? GOLD : "#555",
                fontWeight: 700, fontSize: 10, cursor: "pointer", transition: "all 0.15s",
              }}>{label}</button>
            ))}
          </div>

          {/* Count */}
          <div style={{ fontSize: 10, color: "#444", marginBottom: 12, fontWeight: 600, letterSpacing: 1 }}>
            {filteredStyles.length} STYLES
            {stylesFilter === "mine" && ` MATCHED TO TYPE ${hairType}`}
            {lengthFilter !== "all" && `  ·  ${LENGTH_LABELS[lengthFilter].toUpperCase()} ONLY`}
          </div>

          {filteredStyles.length === 0 ? (
            <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: 24, textAlign: "center" }}>
              <div style={{ fontSize: 13, color: "#444" }}>
                No styles matched your current filters.
                <br />Try switching to "All" or changing the length filter.
              </div>
            </div>
          ) : lengthFilter !== "all" ? (
            // Single length — no grouping headers needed
            filteredStyles.map((style, i) => <StyleCard key={i} style={style} hairType={hairType} />)
          ) : (
            // Grouped by length
            Object.entries(groupedByLength).map(([len, styles]) => (
              <div key={len} style={{ marginBottom: 6 }}>
                {/* Length section header */}
                <div style={{
                  display: "flex", alignItems: "center", gap: 10, marginBottom: 10,
                  paddingTop: 4,
                }}>
                  <div style={{ fontSize: 11, color: GOLD, fontWeight: 700, letterSpacing: 2 }}>
                    {LENGTH_LABELS[len].toUpperCase()} HAIR
                  </div>
                  <div style={{ flex: 1, height: 1, background: BORDER }} />
                  <div style={{ fontSize: 10, color: "#3a3a3a", fontWeight: 600 }}>{styles.length}</div>
                </div>
                {styles.map((style, i) => <StyleCard key={i} style={style} hairType={hairType} />)}
              </div>
            ))
          )}

          {/* Footer tip */}
          <div style={{ marginTop: 8, padding: "12px 14px", background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10 }}>
            <div style={{ fontSize: 11, color: "#444", lineHeight: 1.7 }}>
              Use Google Images or Pinterest to find reference photos. Save your favourite and show it at your barber visit.
            </div>
          </div>
        </div>
      )}

      {/* ── PHOTOS TAB ── */}
      {activeTab === "photos" && (
        <div style={{ padding: 16 }}>
          <div style={{ fontSize: 13, color: "#555", marginBottom: 20, lineHeight: 1.7 }}>
            Days 1, 7, 14 and 30. Progress is invisible in a daily mirror — these photos are your proof.
          </div>
          {PHOTO_DAYS.map(dayNum => {
            const d = days[dayNum];
            const accessible = isDayAccessible(dayNum);
            return (
              <div key={dayNum} style={{ background: CARD, border: `1px solid ${accessible ? BORDER : "#1a1a1a"}`, borderRadius: 10, padding: 20, marginBottom: 14, opacity: accessible ? 1 : 0.45 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800 }}>Day {dayNum}</div>
                    <div style={{ fontSize: 12, color: "#555", marginTop: 2 }}>{!accessible ? "Not yet reached" : d.done ? "Completed" : "Reached — not logged yet"}</div>
                  </div>
                  <div style={{ fontSize: 24 }}>{d.photo ? "✅" : accessible ? "📷" : "🔐"}</div>
                </div>
                {accessible && (
                  <>
                    {d.photo ? (
                      <div style={{ marginBottom: 14 }}>
                        <img src={d.photo} alt={`Day ${dayNum}`} style={{ width: "100%", borderRadius: 8, maxHeight: 220, objectFit: "cover" }} />
                        <button onClick={() => updateDay(dayNum, "photo", null)} style={{ width: "100%", marginTop: 10, padding: 10, borderRadius: 6, background: "transparent", border: `1px solid #c0392b`, color: "#c0392b", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>Remove</button>
                      </div>
                    ) : (
                      <label style={{ display: "block", width: "100%", padding: 16, borderRadius: 8, boxSizing: "border-box", background: GOLD + "11", border: `1.5px dashed ${GOLD}`, color: GOLD, fontWeight: 700, fontSize: 14, cursor: "pointer", textAlign: "center", marginBottom: 14 }}>
                        📷  Upload Day {dayNum} Photo
                        <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => handlePhotoUpload(dayNum, e)} />
                      </label>
                    )}
                    <textarea value={photoLog[dayNum] || ""} onChange={e => { const updated = { ...photoLog, [dayNum]: e.target.value }; setPhotoLog(updated); saveAll({ photoLog: updated }); }}
                      placeholder={`What do you notice on Day ${dayNum}?`}
                      style={{ width: "100%", minHeight: 70, background: CARD2, border: `1px solid ${BORDER}`, borderRadius: 6, color: "#ccc", fontSize: 13, padding: 12, resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "system-ui, sans-serif", lineHeight: 1.6 }}
                    />
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── PRODUCTS TAB ── */}
      {activeTab === "products" && (
        <div style={{ padding: 16 }}>
          <div style={{ background: CARD, border: `1px solid ${GOLD}33`, borderRadius: 10, padding: 18, marginBottom: 18 }}>
            <div style={{ fontSize: 10, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 12 }}>TYPE {hairType} — WHAT TO USE</div>
            <div style={{ fontSize: 13, color: "#777", lineHeight: 2 }}>
              {hairType.startsWith("1") && (<><div>·  Ultra-lightweight water-based pomade (1A/1B)</div><div>·  Volumising mousse at root (1A/1B)</div><div>·  Matte clay for texture (1B/1C)</div><div>·  Argan oil serum + medium cream (1C)</div></>)}
              {hairType.startsWith("2") && (<><div>·  Sulphate-free shampoo only</div><div>·  Sea salt spray for wave definition</div><div>·  Light curl cream applied wet</div><div>·  Microfibre towel — scrunch only, never rub</div></>)}
              {hairType.startsWith("3") && (<><div>·  Moisture-rich curl cream</div><div>·  Weekly deep conditioning mask</div><div>·  LOC: leave-in → oil → cream</div><div>·  Castor oil scalp (3C)  ·  Satin pillowcase nightly</div></>)}
            </div>
          </div>
          <div style={{ fontSize: 10, color: "#3a3a3a", fontWeight: 700, letterSpacing: 2, marginBottom: 12 }}>YOUR LOG</div>
          <textarea value={productLog} onChange={e => { setProductLog(e.target.value); saveAll({ productLog: e.target.value }); }}
            placeholder={"Keeping:\n\nDropping:\n\nTrying next:\n\nWeek notes:"}
            style={{ width: "100%", minHeight: 230, background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, color: "#ccc", fontSize: 13, padding: 18, resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "system-ui, sans-serif", lineHeight: 1.7 }}
          />
        </div>
      )}

      {/* ── BARBER TAB ── */}
      {activeTab === "barber" && (
        <div style={{ padding: 16 }}>
          <div style={{ background: CARD, border: `1px solid ${GOLD}44`, borderRadius: 10, padding: 20, marginBottom: 16 }}>
            <div style={{ fontSize: 10, color: GOLD, fontWeight: 700, letterSpacing: 2, marginBottom: 14 }}>YOUR SCRIPT — SAY THIS WORD FOR WORD</div>
            <div style={{ fontSize: 14, color: "#bbb", lineHeight: 2, background: CARD2, padding: 16, borderRadius: 8, fontStyle: "italic" }}>
              "I want a consistent style for my face shape. My face is{" "}
              <span style={{ color: GOLD, fontWeight: 700, fontStyle: "normal" }}>{faceShape}</span>.{" "}
              I have Type{" "}<span style={{ color: GOLD, fontWeight: 700, fontStyle: "normal" }}>{hairType}</span> hair.
              {(hairType === "1A" || hairType === "1B") && " I have fine hair — please avoid too short on top, I need length to style it."}
              {hairType === "1C" && " My hair is thick — remove weight, point-cut the ends, do not blunt-cut."}
              {hairType.startsWith("2") && " Do not use thinning shears. Work with the wave pattern, not against it."}
              {hairType.startsWith("3") && " Do not thin it or use thinning shears. Work with the curl pattern. No fades or skin tapers."}
              {" "}Can I show you a reference photo?"
            </div>
          </div>
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 18, marginBottom: 16 }}>
            <div style={{ fontSize: 10, color: "#444", fontWeight: 700, letterSpacing: 2, marginBottom: 16 }}>NEVER SAY — SAY THIS INSTEAD</div>
            {[
              ["Just clean it up","Keep the shape, tighten sides, split ends only"],
              ["Make it look good","Show the reference photo. Their version of good isn't yours."],
              ["Take off a little","Exactly half a centimetre from top — nothing from sides"],
              ["Same as usual","Only if the last cut was perfect — otherwise describe it"],
            ].map(([never, instead]) => (
              <div key={never} style={{ display: "flex", gap: 12, marginBottom: 14, fontSize: 13, paddingBottom: 12, borderBottom: `1px solid ${BORDER}` }}>
                <div style={{ color: "#c0392b", minWidth: "42%", textDecoration: "line-through", opacity: 0.8 }}>{never}</div>
                <div style={{ color: "#888" }}>{instead}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 10, color: "#3a3a3a", fontWeight: 700, letterSpacing: 2, marginBottom: 12 }}>VISIT NOTES</div>
          <textarea value={barberNotes} onChange={e => { setBarberNotes(e.target.value); saveAll({ barberNotes: e.target.value }); }}
            placeholder={"Last visit:\nWhat they did:\nWhat worked:\nWhat to change:\nReference photo at:\nNext appointment:"}
            style={{ width: "100%", minHeight: 200, background: CARD, border: `1px solid ${BORDER}`, borderRadius: 10, color: "#ccc", fontSize: 13, padding: 18, resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "system-ui, sans-serif", lineHeight: 1.7 }}
          />
        </div>
      )}

      <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => uploadTargetDay && handlePhotoUpload(uploadTargetDay, e)} />
    </div>
  );
}